import { apiClient } from './client';

export interface APIKey {
  id: string;
  name: string;
  prefix: string;
  key_plain: string | null;
  is_active: boolean;
  expires_at: string | null;
  last_used_at: string | null;
  created_at: string;
  created_by: string | null;
}

export interface APIKeyCreateResponse extends APIKey {
  key: string;
}

export interface Pagination {
  total: number;
  limit: number;
  offset: number;
  has_more: boolean;
}

export interface APIKeyListResponse {
  api_keys: APIKey[];
  pagination: Pagination;
}

export interface APIKeyCreateRequest {
  name: string;
  expires_at?: string | null;
}

export interface APIKeyUpdateRequest {
  name?: string;
  is_active?: boolean;
  expires_at?: string | null;
}

export const apiKeysApi = {
  list: async (): Promise<APIKeyListResponse> => {
    const response = await apiClient.get<APIKeyListResponse>('/api-keys');
    return response.data;
  },

  get: async (keyId: string): Promise<APIKey> => {
    const response = await apiClient.get<APIKey>(`/api-keys/${keyId}`);
    return response.data;
  },

  create: async (data: APIKeyCreateRequest): Promise<APIKeyCreateResponse> => {
    const response = await apiClient.post<APIKeyCreateResponse>('/api-keys', data);
    return response.data;
  },

  update: async (keyId: string, data: APIKeyUpdateRequest): Promise<APIKey> => {
    const response = await apiClient.patch<APIKey>(`/api-keys/${keyId}`, data);
    return response.data;
  },

  delete: async (keyId: string): Promise<void> => {
    await apiClient.delete(`/api-keys/${keyId}`);
  },
};

export default apiKeysApi;
